import { createAsyncAction } from '../../util/asyncActions';
export const fetchPlaybooks = createAsyncAction('FETCH_PLAYBOOKS')();
export const fetchRecommendedPlaybooks = createAsyncAction('FETCH_RECOMMENDED_PLAYBOOKS')();
export const fetchPlaybooksWithRecommendations = createAsyncAction('FETCH_PLAYBOOKS_WITH_RECOMMENDATIONS')();
export const switchToCardListView = view => ({
  type: 'SWITCH_TO_CARDLIST_VIEW',
  view
});